import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeComponentCtaLinkSkeleton } from './TypeComponentCtaLink'
import type { TypeHeaderCardSkeleton } from './TypeHeaderCard'

export interface TypeHeaderRichMenuFields {
  internalName: EntryFieldTypes.Symbol
  title: EntryFieldTypes.Symbol
  cards?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeHeaderCardSkeleton>>
  links?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeComponentCtaLinkSkeleton>>
  includeNewsletter?: EntryFieldTypes.Boolean
  backgroundColor?: EntryFieldTypes.Symbol<'Light Gray' | 'White'>
  shouldAlwaysBeFullWidth?: EntryFieldTypes.Boolean
}

export type TypeHeaderRichMenuSkeleton = EntrySkeletonType<TypeHeaderRichMenuFields, 'headerRichMenu'>
export type TypeHeaderRichMenu<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeHeaderRichMenuSkeleton,
  Modifiers,
  Locales
>

export function isTypeHeaderRichMenu<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeHeaderRichMenu<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'headerRichMenu'
}
